const { fetchJsonApi } = require('./abstract');
const { getApiLanguage } = require('./language');
const { getProvider } = require('./platform');
const { REWARDED_VIDEO_LOOTPACK_PLATFORMS } = require('../constants');

function fetchLandingPage(apiUrl, pageIdOrKey, { country, platform } = {}, version) {
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: `v2/landingPages/${pageIdOrKey}`,
    query: {
      lang: getApiLanguage(),
      country,
      platform,
      rewardedVideoLootpack: REWARDED_VIDEO_LOOTPACK_PLATFORMS[getProvider()],
      version,
    },
    expectedStatus: 200,
    description: 'Fetching landing page',
  }).catch((error) => {
    if (error.status === 404) {
      return { disabled: true };
    }
    throw error;
  });
}

module.exports = {
  fetchLandingPage,
};
